import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "ECサイトのスピーディーなSEO改修を実現いたしました。このプロジェクトでは、弊社の自社プロダクト\"flamingo\"をご導入いただき、効率的なPDCAを回せないという課題を解決いたしました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const nissenPageMeta: PageMeta = {
  title: "ニッセンオンライン | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "UIUX モバイルアプリ システム化 DX推進 フロントエンド開発",
  image: primaryImage,
  url: `${SITE_URL}/cases/nissen/`,
}

export const nissenSchema = buildCaseStudySchema({
  slug: "nissen",
  pageTitle: nissenPageMeta.title,
  description: nissenPageMeta.description,
  headline: "ニッセンオンライン",
  alternativeHeadline: "株式会社ニッセン",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/nissen.webp"],
  clientName: "株式会社ニッセン",
  breadcrumbLabel: "ニッセンオンライン",
})
